const RATINGS = {
  good: 1,
  average: 0.5,
  bad: 0,
};

// eslint-disable-next-line import/prefer-default-export
export { RATINGS };
